import React, { useState } from 'react';
import { Container, Form, Button, Card, Alert,Spinner  } from 'react-bootstrap';
import api from '../services/api';

const SignUpForm = () => {
  // State for form data and messages
  const [formData, setFormData] = useState({
    email: '',
    username: '',
    password: '',
  });
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
 const [isLoading, setIsLoading] = useState(false);
  // Handle changes to form inputs
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    setSuccessMessage('');
    setIsLoading(true);

    // The domain validation logic has been removed from here.

    try {
      const response = await api.post('users/signup/', formData, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.status === 200 && response.data.success) {
        setSuccessMessage(response.data.message);
        setFormData({ email: '', username: '', password: '' });
        setErrorMessage('');
      }
    } catch (error) {
      if (error.response && error.response.data) {
        const backendError = error.response.data.error || 'Something went wrong';
        setErrorMessage(backendError);
      } else {
        setErrorMessage('Failed to sign up. Please try again later.');
      }
      setSuccessMessage('');
    } finally {
      setIsLoading(false); // Stop loading regardless of outcome
    }
  };

  return (
    <Container className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
      <Card style={{ width: '30rem', padding: '2rem' }}>
        <Card.Body>
          <Card.Title className="text-center">Sign Up</Card.Title>
          <hr />
          {successMessage && <Alert variant="success">{successMessage}</Alert>}
          {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formBasicEmail" className="mb-3">
              <Form.Label>Email address</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                // Removed the 'isInvalid' prop
                required
              />
              {/* Removed the Form.Control.Feedback component */}
            </Form.Group>

            <Form.Group controlId="formBasicUsername" className="mb-3">
              <Form.Label>Username</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter username"
                name="username"
                value={formData.username}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="formBasicPassword" className="mb-4">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Enter password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <div className="d-grid">
            <Button variant="primary" type="submit" disabled={isLoading}>
              {isLoading ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  <span className="ms-2">Signing Up...</span>
                </>
              ) : (
                'Sign Up'
              )}
            </Button>
          </div>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default SignUpForm;